import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { matchingInputsValidator } from "../../../validators/matchingInputs";
import { PortalService } from "../../../services/portal-service.service";
import { AuthService } from "../../../services/auth.service";
import { UserDetails } from "../../../models/user";
import { LogService } from "../../../services/log.service";

@Component({
  standalone: false,
  selector: "app-change-password-tab",
  templateUrl: "./change-password-tab.component.html",
  styleUrls: ["./change-password-tab.component.scss"],
})
export class ChangePasswordTabComponent implements OnInit {
  ChangePasswordForm: UntypedFormGroup;
  error: any = null;
  success = false;
  changing = false;
  userData: UserDetails = new UserDetails();
  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private portalService: PortalService,
    private logService: LogService,
  ) {}

  ngOnInit() {
    this.ChangePasswordForm = this.fb.group(
      {
        password: ["", [Validators.required]],
        confirm: ["", [Validators.required]],
        currentpass: ["", [Validators.required]],
      },
      { validator: matchingInputsValidator("password", "confirm") },
    );
    this.get_details();
  }
  get f() {
    return this.ChangePasswordForm.controls;
  }

  async get_details() {
    const user = this.authService.getToken();
    let userId = null;
    if (user) {
      userId = this.authService.JWTDecode(user).sub;
      this.userData = await this.portalService.getUser(userId);
    }
  }

  resetMessage() {
    this.error = null;
    this.success = false;
  }

  async changePassword() {
    this.resetMessage();
    if (this.changing) return;
    this.changing = true;
    const userId = this.userData.id;
    const data = {
      currentPassword: this.f.currentpass.value,
      password: this.f.password.value,
      username: this.userData.username,
    };
    try {
      await this.portalService.changePassword(userId, data);
      this.success = true;
      this.authService.logout();
    } catch (error) {
      this.error = error;
      this.success = false;
    } finally {
      this.changing = false;
    }
  }

  changePasswordDisabled(): boolean {
    return this.changing || this.ChangePasswordForm.invalid;
  }
} // end
